<template>
  <div id="root">
    <div style="outline:none" tabindex="-1" role="group">
      <div class="main-container">
        <div class="app-container">
          <div class="main-page-container">
            <div style="outline:none" tabindex="-1" role="group">
              <div class="page-container article-type">
                <Header />
                <div class="page-wrapper bg-layer">
                  <section
                    style="z-index:13;margin-top:81px"
                    class="main-cover-component bg-layer introduction-layout cover-video-dsk cover-video-mb pro-header"
                  >
                    <div class="cover-container">
                      <div class="player-container">
                        <video
                          :src="$route.query.type == '23%E5%8C%BA'?'media/23.9492164d.mp4':'media/ibc.9a9ad285.mp4'"
                          :poster="$route.query.type == '23%E5%8C%BA'?'media/23.9492164d.mp4':'media/ibc.9a9ad285.mp4'"
                          preload="no"
                          autoplay="autoplay"
                          loop="loop"
                          webkit-playsinline=""
                          playsinline=""
                          x5-video-player-type="h5"
                          x5-video-player-fullscreen="true"
                          x5-video-orientation="portraint"
                          x-webkit-airplay="true"
                        >
                          <source
                            v-if="$route.query.type == '23%E5%8C%BA'"
                            src="../assets/video/23.mp4"
                            type="video/mp4"
                          />
                          <source
                            v-else
                            src="../assets/video/ibc.mp4"
                            type="video/mp4"
                          />
                        </video>
                      </div>
                    </div>
                  </section>
                  <!-- <div class="pro-top">
                    <div class="buts">
                      <div
                        class="swiper-button-next swiper-top-button-next swiper-button-white"
                        slot="button-next"
                        @click="nextFn"
                      ></div>
                      <div
                        class="swiper-button-prev swiper-top-button-prev swiper-button-white"
                        slot="button-prev"
                        @click="prevFn"
                      ></div>
                    </div>
                    <img :src="url + '/upload/' + nowPic"  v-if="nowPic"/>
                  </div> -->
                  <div class="swpier-box">
                    <swiper
                      :options="swiperOption1"
                      ref="swiperThumbs"
                      class="pro-bottom"
                      v-if="list.length > 0"
                    >
                      <!-- slides -->
                      <swiper-slide v-for="(item, index) in list" :key="index">
                        <img :src="url + '/upload/' + item" />
                      </swiper-slide>
                      <!-- Optional controls -->

                      <!-- 如果需要导航条-->
                    </swiper>
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// console.log(Swiper);
// import 'swiper/css/swiper.css'
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
export default {
  name: "locator",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      id: null,
      url: this.$api,
      list: [],
      index: 0,
      nowPic: "",
      swiperOption1: {
        // 参数选项,显示小点
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        loop: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        },
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev"
        // pagination: ".swiper-pagination"
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  async created() {
    let { data } = await axios.get(
      this.$api + "/Api/Product_Get/" + this.$route.query.id
    );
    let list = data.data[0].pics;
    if (list.length > 0) {
      list = list.split(",");
    }
    this.list = list;
    this.nowPic = list[0];
    // console.log(this.$refs.swiperThumbs)
  },
  methods: {
    nextFn() {
      console.log(this.$refs.swiperThumbs.swiper);
      this.$refs.swiperThumbs.swiper.slideNext();
      this.nowPic = this.list[this.index];
    },
    prevFn() {
      this.$refs.swiperThumbs.swiper.slidePrev();
    }
  }
};
</script>

<style  lang="less" scoped>
.swiper-container {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
  margin: 50px auto;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
  background: 0 0 !important;
  width: 300px;
  height: 500px;
  display: flex;
  /*主轴居中对齐*/
  justify-content: center;
  /*侧轴居中对齐*/
  align-items: center;
}
.swiper-slide img {
  width: 100%;
}
/deep/.swiper-container-3d .swiper-slide-shadow-left {
  background-image: none;
}
/deep/.swiper-container-3d .swiper-slide-shadow-right {
  background-image: none;
}
.swpier-box {
  position: relative;
  width: 100%;
}
/deep/.swiper-button-prev,/deep/.swiper-button-next{
  background-image:none
}
/deep/.swiper-button-next:after, /deep/.swiper-button-prev:after{
  color: #5f4f46;
}
</style>